export default __webpack_public_path__ + "static/media/clock.ddec723d.svg";